import { ThermostatBrand } from '@/types/brand'

export enum ThermostatBrandName {
  Ecobee = 'ecobee',
  Nest = 'nest',
  Honeywell = 'honeywell',
}

export const findBrandByPortal = (portal: string) =>
  brands.find((brand) => brand.id === portal.toLowerCase())

export const brands = [
  {
    id: ThermostatBrandName.Ecobee,
    name: 'Ecobee',
    logo: '/dashboard/img/brands/ecobee.webp',
    deviceImage: '/img/ecobee.webp',
  },
  {
    id: ThermostatBrandName.Nest,
    name: 'Nest',
    logo: '/dashboard/img/brands/nest.webp',
    deviceImage: '/img/nest.webp',
  },
  {
    id: ThermostatBrandName.Honeywell,
    name: 'Honeywell',
    logo: '/dashboard/img/brands/honeywell.webp',
    deviceImage: '/img/honeywell.webp',
  },
] as ThermostatBrand[]

export default brands
